module.exports = __webpack_public_path__ + "img/b1-2.70076db.png";